import { buildQuery, requestJson } from "./apiClient";

const BASE = "/api/admin/client-views/launch";

export function listLaunchTemplates() {
  return requestJson(`${BASE}/templates`);
}

export function listLaunchClientViews() {
  return requestJson(`${BASE}/views`);
}

export function createClientViewFromTemplate(payload) {
  return requestJson(`${BASE}/from-template`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function cloneClientViewLaunch(payload) {
  return requestJson(`${BASE}/clone`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function validateManifestImport(payload) {
  return requestJson(`${BASE}/import/validate`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function importManifestBundle(payload) {
  return requestJson(`${BASE}/import`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function getLaunchChecklist(clientViewId) {
  return requestJson(`${BASE}/${clientViewId}/checklist`);
}

export function runLaunchChecklist(clientViewId) {
  return requestJson(`${BASE}/${clientViewId}/checklist/run`, {
    method: "POST",
    body: JSON.stringify({}),
  });
}

export function skipLaunchChecklistItem(clientViewId, itemKey) {
  return requestJson(`${BASE}/${clientViewId}/checklist/items/${itemKey}/skip`, {
    method: "POST",
    body: JSON.stringify({}),
  });
}

export function getLaunchReadiness(clientViewId) {
  return requestJson(`${BASE}/${clientViewId}/readiness`);
}

export function exportClientViewBundle(clientViewId, params = {}) {
  return requestJson(`${BASE}/${clientViewId}/export${buildQuery(params)}`);
}

export function completeLaunchReview(clientViewId, payload = {}) {
  return requestJson(`${BASE}/${clientViewId}/launch-review`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function downloadClientViewBundle(clientViewId, version = "draft") {
  const url = `${BASE}/${clientViewId}/export?version=${encodeURIComponent(version)}&format=download`;
  return fetch(url, { credentials: "include" }).then(async (res) => {
    if (!res.ok) {
      const body = await res.json().catch(() => ({}));
      throw new Error(body.message || "Export failed.");
    }
    return res.blob();
  });
}
